import { slotObjectToDataTestIds } from '@elliemae/ds-system';
export const DSButtonV3Name = 'DSButtonv3';

export const DSButtonV3Slots = {
  ROOT: 'root',
};
export const DSButtonV3DataTestId = {
  ...(slotObjectToDataTestIds(DSButtonV3Name, DSButtonV3Slots) as Record<keyof typeof DSButtonV3Slots, string>),
  ROOT: 'ds-button',
};
